/** @format */

// import {filter} from 'lodash';
import React, { useEffect, useState } from "react";
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
  CardContent,
  Chip,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
//
import { useNavigate, useParams } from "react-router-dom";
import Iconify from "../../components/Iconify";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
// import PhoneNumber from "../../dao/PhoneNumber";
// import Waba from "../../dao/Waba";
import Select from "react-select";
// import swal from "../../reusables/CustomSwal";

import BroadcastDao from "src/dao/Broadcast";
import { FaCheckDouble, FaRegCheckCircle } from "react-icons/fa";

// import qs from "qs";
// import { useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";
import CardHeaderDashboard from "./CardHeader";
import moment from "moment";
// ----------------------------------------------------------------------

const statusOptions = [
  { label: "All", value: "all" },
  { label: "Connected", value: "connected" },
  { label: "Failed", value: "failed" },
];

const TABLE_HEAD = [
  { id: "name", label: "Name", alignRight: false },
  { id: "phone_number", label: "Phone Number", alignRight: false },
  { id: "date_send", label: "Date Send", alignRight: false },
  { id: "delivered", label: "Delivered", alignRight: false },
  { id: "status", label: "Status", alignRight: false },
];

// ----------------------------------------------------------------------
export default function Broadcast(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  //   const location = useLocation();

  //   const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  // let idParam = queryParams.waba_id

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("F");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [setCount] = useState(page * rowsPerPage + 1);

  const [data, setData] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(true);
  const [headerData, setHeaderData] = useState({});
  // const [isDataFetched] = useState(true);

  const [selectedStatus, setSelectedStatus] = useState({
    label: "All",
    value: "All",
  });

  //   let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCount(page * rowsPerPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const fetchHeader = async () => {
    setIsDataFetched(true);
    try {
      let result = await BroadcastDao.getDetailHeader(id);
      setHeaderData(result.headerData[0] ?? {});
      setData(result?.dataList ?? []);
      setIsDataFetched(false);
    } catch (error) {
      console.error(error);
      setIsDataFetched(false);
    }
  };

  useEffect(() => {
    let isFetch = true;

    if (isFetch) fetchHeader();

    return () => {
      isFetch = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const colorMap = (status) => {
    switch (status) {
      case "sent":
        return "warning";
      case "delivered":
        return "success";
      case "read":
        return "primary";
      case "failed":
        return "error";
      default:
        return "info";
    }
  };

  const downloadBroadcast = async () => {
    try {
      let result = await BroadcastDao.getBroadcast(id);
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `broadcast_${headerData?.name ?? ""}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error);
    }
  };

  //   const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage) : 0;
  const filteredData = applySortFilter(
    data,
    getComparator(order, orderBy),
    filterName,
    "name"
  );
  const notFound = filteredData.length === 0;

  return (
    <Page title="Broadcast">
      <Container>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            onClick={() => {
              navigate(-1);
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <Iconify
              width={60}
              height={60}
              color={"#DBDBDB"}
              icon="ion:arrow-back-circle"
              sx={{ marginRight: 1 }}
            />
          </div>

          <Stack direction="column" justifyContent="center">
            <Typography variant="h4">{headerData?.name ?? ""}</Typography>
            <Typography style={{ color: "#8E8EA1" }} gutterBottom>
              {/* Sent By : Rara Avis <br /> */}
              Date :{" "}
              {moment(headerData?.created_at).format("DD MMM YYYY HH:mm")}
            </Typography>
          </Stack>
        </div>

        <Row
          style={{
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Col md={3}>
            <CardHeaderDashboard
              label="Sent"
              value={headerData?.total_sent ?? 0}
              icon={<FaCheckDouble fontSize={"1.5em"} />}
              backgroundColor={"#FFB74A"}
            />
          </Col>
          <Col md={3}>
            <CardHeaderDashboard
              label="Delivered"
              value={headerData?.total_delivered ?? 0}
              icon={<FaRegCheckCircle fontSize={"1.5em"} />}
              backgroundColor={"#00A389"}
            />
          </Col>
          <Col md={3}>
            <CardHeaderDashboard
              label="Read"
              value={headerData?.total_read ?? 0}
              icon={<FaCheckDouble fontSize={"1.5em"} />}
              backgroundColor={"#6160DC"}
            />
          </Col>
          <Col md={3}>
            <CardHeaderDashboard
              label="Failed"
              value={headerData?.total_failed ?? 0}
              icon={
                <Iconify
                  icon="mdi:warning-circle"
                  width={"2em"}
                  height={"2em"}
                />
              }
              backgroundColor={"#FF4A55"}
            />
          </Col>
        </Row>

        <Card>
          <CardContent>
            <Row>
              <Col
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                }}
                md={6}
              >
                <SearchToolbar
                  filterName={filterName}
                  onFilterName={handleFilterByName}
                />
              </Col>
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                md={3}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <Select
                    style={{ width: "100%", flex: 1 }}
                    onChange={(option) => {
                      setSelectedStatus(option);
                    }}
                    value={selectedStatus}
                    options={statusOptions}
                  />
                </div>
              </Col>
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                md={3}
              >
                <Button
                  fullWidth={true}
                  variant={"contained"}
                  onClick={() => {
                    downloadBroadcast();
                  }}
                >
                  Export Broadcast
                </Button>
              </Col>
            </Row>
          </CardContent>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table style={{ backgroundColor: "white", color: "white" }}>
                <SortableTableHeader
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { name, phone, date_sent, date_received, status } =
                        row;
                      return (
                        <TableRow
                          hover
                          key={row.id}
                          tabIndex={-1}
                          role="checkbox"
                        >
                          <TableCell align="left">{name}</TableCell>
                          <TableCell align="left">{phone}</TableCell>
                          <TableCell align="left">
                            {moment(date_sent).format("DD MMM YYYY HH:mm")}
                          </TableCell>
                          <TableCell align="left">
                            {moment(date_received).format("DD MMM YYYY HH:mm")}
                          </TableCell>
                          <TableCell align="left">
                            <Chip
                              color={colorMap(status)}
                              label={status.toUpperCase()}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {(notFound || !isDataFetched) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {isDataFetched ? (
                          <CircularProgress />
                        ) : (
                          <SearchNotFound searchQuery={filterName} />
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 20, 50, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
